module.exports = __webpack_public_path__ + "static/typescripLogo-808d18754aa63d7ec0bd02d2f16434fb.svg";